class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.onClickHandler = this.onClickHandler.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));
    facetForm.addEventListener('click', this.onClickHandler);

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      })
      .catch((error) => {
        FacetFiltersForm.resetLoadingState();
        console.error(error);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      const el = document.querySelector(selector);
      if (el) el.innerHTML = html.querySelector(selector).innerHTML;
    });

    html.querySelectorAll('[data-sort-instance]').forEach((sourceElement) => {
      document.querySelectorAll(`[data-sort-instance="${sourceElement.dataset.sortInstance}"]`).forEach((targetElement) => {
        targetElement.innerHTML = sourceElement.innerHTML;
        targetElement.className = sourceElement.className;
      });
    });

    const mobileForm = document.getElementById('FacetFiltersFormMobile');
    if (mobileForm && mobileForm.closest('menu-drawer')) {
      mobileForm.closest('menu-drawer').bindEvents();
    }
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static resetLoadingState() {
    const productGrid = document.getElementById('ProductGridContainer');
    const collection = productGrid ? productGrid.querySelector('.collection') : null;
    const productCount = document.getElementById('ProductCount');
    const productCountDesktop = document.getElementById('ProductCountDesktop');

    if (collection) collection.classList.remove('loading');
    if (productCount) productCount.classList.remove('loading');
    if (productCountDesktop) productCountDesktop.classList.remove('loading');
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onClickHandler(event) {
    const applyButton = event.target.closest('[data-mobile-facets-apply]');
    if (!applyButton) return;

    event.preventDefault();

    const form = event.target.closest('form');
    if (!form) return;

    const searchParams = this.createSearchParams(form);
    this.onSubmitForm(searchParams, event);

    const menuDrawer = this.closest('menu-drawer');
    const summary = menuDrawer ? menuDrawer.querySelector('summary') : null;
    if (menuDrawer && summary) menuDrawer.closeMenuDrawer(event, summary);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class FacetSortDropdown {
  static init() {
    if (this.initialized) return;

    document.addEventListener('click', this.onDocumentClick.bind(this));
    document.addEventListener('keydown', this.onDocumentKeydown.bind(this));
    document.addEventListener('focusin', this.onDocumentFocusIn.bind(this));

    this.initialized = true;
  }

  static getContainer(element) {
    return element ? element.closest('[data-facet-sort]') : null;
  }

  static getTrigger(container) {
    return container ? container.querySelector('.custom-select__trigger') : null;
  }

  static getMenu(container) {
    return container ? container.querySelector('.custom-select__options') : null;
  }

  static getHiddenInput(container) {
    return container ? container.querySelector('input[name="sort_by"]') : null;
  }

  static getOptions(container) {
    return container ? Array.from(container.querySelectorAll('.custom-select__option')) : [];
  }

  static getSelectedOption(container) {
    return container ? container.querySelector('.custom-select__option[aria-selected="true"]') : null;
  }

  static isOpen(container) {
    return Boolean(container && container.classList.contains('is-open'));
  }

  static onDocumentClick(event) {
    const trigger = event.target.closest('.custom-select__trigger');
    const option = event.target.closest('.custom-select__option');

    if (option) {
      const container = this.getContainer(option);
      if (!container) return;

      event.preventDefault();
      this.selectOption(container, option);
      return;
    }

    if (trigger) {
      const container = this.getContainer(trigger);
      if (!container) return;

      event.preventDefault();
      this.toggle(container);
      return;
    }

    this.closeAll();
  }

  static onDocumentKeydown(event) {
    const container = this.getContainer(event.target);
    if (!container) return;

    const options = this.getOptions(container);
    if (!options.length) return;

    const currentOption = event.target.closest('.custom-select__option');
    const selectedOption = this.getSelectedOption(container) || options[0];
    const currentIndex = currentOption ? options.indexOf(currentOption) : options.indexOf(selectedOption);

    switch (event.key) {
      case 'ArrowDown':
        event.preventDefault();
        if (!this.isOpen(container)) {
          this.open(container);
          this.focusOption(container, selectedOption);
        } else {
          this.focusOption(container, options[Math.min(currentIndex + 1, options.length - 1)]);
        }
        break;
      case 'ArrowUp':
        event.preventDefault();
        if (!this.isOpen(container)) {
          this.open(container);
          this.focusOption(container, selectedOption);
        } else {
          this.focusOption(container, options[Math.max(currentIndex - 1, 0)]);
        }
        break;
      case 'Home':
        if (!this.isOpen(container)) return;
        event.preventDefault();
        this.focusOption(container, options[0]);
        break;
      case 'End':
        if (!this.isOpen(container)) return;
        event.preventDefault();
        this.focusOption(container, options[options.length - 1]);
        break;
      case 'Enter':
      case ' ':
        if (!currentOption) {
          event.preventDefault();
          this.toggle(container);
          if (!this.isOpen(container)) return;
          this.focusOption(container, selectedOption);
          return;
        }

        event.preventDefault();
        this.selectOption(container, currentOption);
        break;
      case 'Escape': {
        if (!this.isOpen(container)) return;
        event.preventDefault();
        this.close(container);
        const trigger = this.getTrigger(container);
        if (trigger) trigger.focus();
        break;
      }
      case 'Tab':
        this.close(container);
        break;
    }
  }

  static onDocumentFocusIn(event) {
    const container = this.getContainer(event.target);
    if (container) return;

    this.closeAll();
  }

  static open(container) {
    const trigger = this.getTrigger(container);
    const menu = this.getMenu(container);

    if (!trigger || !menu) return;

    this.closeAll(container);
    container.classList.add('is-open');
    trigger.setAttribute('aria-expanded', 'true');
    menu.setAttribute('aria-hidden', 'false');
    const selectedOption = this.getSelectedOption(container);
    if (selectedOption) trigger.setAttribute('aria-activedescendant', selectedOption.id);
  }

  static close(container) {
    const trigger = this.getTrigger(container);
    const menu = this.getMenu(container);

    if (!trigger || !menu) return;

    container.classList.remove('is-open');
    trigger.setAttribute('aria-expanded', 'false');
    menu.setAttribute('aria-hidden', 'true');
    trigger.removeAttribute('aria-activedescendant');
  }

  static toggle(container) {
    if (this.isOpen(container)) {
      this.close(container);
      return;
    }

    this.open(container);
  }

  static closeAll(exception) {
    document.querySelectorAll('[data-facet-sort].is-open').forEach((container) => {
      if (container !== exception) this.close(container);
    });
  }

  static focusOption(container, option) {
    const trigger = this.getTrigger(container);
    if (!option) return;

    option.focus();
    option.scrollIntoView({ block: 'nearest' });
    if (trigger) trigger.setAttribute('aria-activedescendant', option.id);
  }

  static selectOption(container, option) {
    const hiddenInput = this.getHiddenInput(container);
    const trigger = this.getTrigger(container);
    const label = container.querySelector('[data-sort-label]');
    const form = container.closest('form');
    const nextValue = option.dataset.value;

    if (!hiddenInput || !trigger || !label || !form || !nextValue) return;

    this.getOptions(container).forEach((item) => {
      const isSelected = item === option;
      item.classList.toggle('facet-sort__option--selected', isSelected);
      item.setAttribute('aria-selected', isSelected ? 'true' : 'false');
    });

    hiddenInput.value = nextValue;
    label.textContent = option.dataset.label || option.textContent.trim();
    trigger.setAttribute('aria-activedescendant', option.id);

    this.close(container);
    trigger.focus();
    hiddenInput.dispatchEvent(new Event('input', { bubbles: true }));
  }
}

FacetSortDropdown.initialized = false;
FacetSortDropdown.init();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) =>
      element.addEventListener('change', this.onRangeChange.bind(this))
    );
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
